import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment-timezone";

// Components
import SectionBanner from "../../utils/SectionBanner";
import ConfirmTrainingEducationSignupDialog from "../../utils/dialogs/ConfirmTrainingEducationSignupDialog";
import ConfirmTrainingEducationCancelDialog from "../../utils/dialogs/ConfirmTrainingEducationCancelDialog";

// CSS
import "../../../css/list-item.css";

// State
import {
	signupReviewerToTrainingEducation,
	trainingEducationSignupReset,
	cancelReviewerTrainingEducation,
	trainingEducationCancelReset
} from "../../../store/actions/trainingEducation";

// Util
import { nl2br } from "../../../utils/nl2br";

class TrainingEducationItem extends Component {
	constructor(props) {
		super(props);

		this.state = {
			inProcess: false,
			showRegisterDialog: false,
			showCancelDialog: false
		};
	}

	render() {
		const { translations, user, item, trainingEducation } = this.props;

		// Defined the possible buttons we could have depending on whether or not the user has registered for this item
		const propTypes = {
			buttonSignup: {
				text: (
					<React.Fragment>
						{translations.sections.training_education.signup_label}
						<span className="icon-checkmark" />
					</React.Fragment>
				),
				onClick: () =>
					this.setState({
						showRegisterDialog: true
					}),
				isDisabled: trainingEducation.signupInProcess
			},
			buttonCancel: {
				text: `Cancel`,
				onClick: () =>
					this.setState({
						showCancelDialog: true
					}),
				isDisabled: trainingEducation.signupInProcess,
				classes: "cancel"
			}
		};

		// Is user signed-up for this item?
		const signedUp =
			!!user.training_education_signups &&
			user.training_education_signups.filter(
				signup => signup.training_education_id === item.id
			).length;

		return (
			<div className={`list-item` + (signedUp ? ` list-item--active` : ``)}>
				<SectionBanner button={signedUp ? propTypes.buttonCancel : propTypes.buttonSignup}>
					{item.title}
				</SectionBanner>
				<div className="list-item--content">
					<div className="list-item--description">{nl2br(item.description)}</div>
					<div className="list-item--date">
						<span className="date--label">
							{translations.sections.training_education.date_added_label}:
						</span>
						<span>
							{moment
								.utc(item.date_added)
								.local()
								.format("MMM D, Y")}
						</span>
					</div>
				</div>

				<ConfirmTrainingEducationSignupDialog
					show={this.state.showRegisterDialog}
					inProgress={trainingEducation.signupInProcess}
					itemTitle={item.title}
					handleAction={() => this.props.signupReviewerToTrainingEducation(item)}
					handleClose={() => {
						// Reset store (error messages, etc)
						this.props.trainingEducationSignupReset();

						// Reset local state
						this.setState({
							showRegisterDialog: false,
							error: null,
							success: null
						});
					}}
					errors={trainingEducation.signupError}
					success={trainingEducation.signupSuccess}
				/>

				<ConfirmTrainingEducationCancelDialog
					show={this.state.showCancelDialog}
					inProgress={trainingEducation.cancelInProcess}
					itemTitle={item.title}
					handleAction={() => this.props.cancelReviewerTrainingEducation(item)}
					handleClose={() => {
						// Reset store (error messages, etc)
						this.props.trainingEducationCancelReset();

						// Reset local state
						this.setState({
							showCancelDialog: false,
							error: null,
							success: null
						});
					}}
					errors={trainingEducation.cancelError}
					success={trainingEducation.cancelSuccess}
				/>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		translations: state.translations.translations,
		user: state.user.reviewer.user,
		trainingEducation: state.trainingEducation
	};
};

export default connect(
	mapStateToProps,
	{
		signupReviewerToTrainingEducation,
		trainingEducationSignupReset,
		cancelReviewerTrainingEducation,
		trainingEducationCancelReset
	}
)(TrainingEducationItem);



// WEBPACK FOOTER //
// ./src/components/training/education/TrainingEducationItem.js